import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { EnvironmentConfiguration } from '@rx-applications/clientsite/shared/config/utils';
import { HttpService } from '@rx-applications/shared/utils';
import { ENV_CONFIG_URL } from '../constants';

@Injectable({
  providedIn: 'root'
})
export class EnvConfigApi {
  readonly httpService = inject(HttpService);
  readonly httpClient = inject(HttpClient)

  getEnvConfig(): Observable<EnvironmentConfiguration> {
    return this.httpClient.get<EnvironmentConfiguration>(ENV_CONFIG_URL);
  }
}
